import { render } from "./configuracion.vue?vue&type=template&id=7034eb9c&scoped=true"
import script from "./configuracion.vue?vue&type=script&lang=js"
export * from "./configuracion.vue?vue&type=script&lang=js"

import "./configuracion.vue?vue&type=style&index=0&id=7034eb9c&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7034eb9c"]])

export default __exports__